export default "__VITE_ASSET__5eb65a26__"